export enum PlaceholderName {
  HelpDeskNumber = 'HelpdeskNumber',
}
